import React, {useEffect,useState} from 'react'
import { Pagination } from '@mui/material/Pagination'
const ExerciseDetails = () => {
  return (
    <div>
      yoyo
    </div>
  )
}

export default ExerciseDetails
